/**
 * Copyright (C), 2012-2021, Sichuan Xiaoka Technology Co., Ltd.
 * 常量数据
 * */

/**
 * 性别
 * @type {Array}
 */
const GENDER = [
    {value: 1, label: '男'},
    {value: 2, label: '女'},
    {value: 3, label: '保密'}
]

let SEATNUMBERARR = []
for (let i = 5; i < 59; i++) {
    SEATNUMBERARR.push({
        value: i,
        label: i + '座'
    })
}

/**
 * 座位数量
 * @type {Array}
 */
const SEATNUMBER = SEATNUMBERARR
/**
 * 线路类型
 * @type {Array}
 */
const LINETYPE = [
    {value: 1, label: '站 - 站'},
    {value: 2, label: '站 - 送'},
    {value: 3, label: '接 - 送'},
    {value: 4, label: '接 - 站'}
]
/**
 * 线路类型
 * @type {Array}
 */
const ORDERASSIGNMETHOD = [
    {value: 1, label: '人工'},
    {value: 2, label: '自动'}
]
/**
 * 专线订单状态
 * @type {Array}
 */
const ORDERSTATUS = [
    {value: 10, label: '待开始', type: 'danger'},
    {value: '15,20,25,30,35,40', label: '行程中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已退票', type: 'info'},
    {value: 1, label: '待支付', type: ''},
]


const ORDERSTATUS2 = [
    {value: 1, label: '待支付', type: ''},
    {value: 10, label: '待检票', type: 'warning'},
    {value: 3, label: '已检票', type: 'success'},
    {value: 60, label: '已退票', type: 'info'}
]
/**
 * 旅游包车订单状态
 * @type {Array}
 */
const ORDERCHARTEREDSTATUS = [
    {value: 1, label: '待支付', type: ''},
    {value: '5,10', label: '待开始', type: 'danger'},
    {value: '15,20,25,30,35,40', label: '行程中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已退票', type: 'info'}
]

/**
 * 顺风车订单状态
 * @type {Array}
 */
const HITCHHIKING = [
    {value: '10', label: '待开始', type: 'danger'},
    {value: '20,25,35,40', label: '行程中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'},
    {value: 65, label: '已退款', type: 'info'},
]
/**
 * 场站订单状态
 * @type {Array}
 */
const CZHITCHHIKING = [
    {value: '5,10', label: '待开始', type: 'danger'},
    {value: '35,40', label: '行程中', type: 'warning'},
    {value: 43, label: '待支付', type: ''},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]
const CZHITCHHIKINGDAN = [
    {value: 5, label: '待指派', type: 'danger'},
    {value: 10, label: '待上车', type: 'danger'},
    {value: 35, label: '已上车', type: 'warning'},
    {value: 40, label: '已出发', type: 'warning'},
    {value: 43, label: '待支付', type: ''},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]
const HITCHHIKINGDAN = [
    {value: 10, label: '待开始', color: '#409EFF', type: 'primary'},
    {value: 20, label: '行程中', color: '#e6a23c', type: 'warning'},
    {value: 25, label: '行程中', color: '#e6a23c', type: 'warning'},
    {value: 35, label: '行程中', color: '#e6a23c', type: 'warning'},
    {value: 40, label: '行程中', color: '#e6a23c', type: 'warning'},
    {value: 45, label: '已完成', color: '#67c23a', type: 'success'},
    {value: 60, label: '已取消', color: '#909399', type: 'info'},
    {value: 65, label: '已退款', color: '#909399', type: 'info'},
]

const CANCELCHANNEL = [
    {value: 'cancel_channel_mt', label: '乘客取消'},
    {value: 'cancel_channel_system', label: '客服取消'},
    {value: 'cancel_channel_driver', label: '司机取消'},
]

/**
 * 工单状态
 * @type {Array}
 */
const HITCHHIKINGWORK = [
    {value: '10', label: '待开始', color: '#409EFF', type: 'danger'},
    {value: '40', label: '行程中', color: '#e6a23c', type: 'warning'},
    {value: 45, label: '已完成', color: '#67c23a', type: 'success'},
    {value: 60, label: '已取消', color: '#909399', type: 'info'}
]
const HITCHHIKINGWORKTWO = [
    {value: '10', label: '待开始', type: 'danger'},
    {value: '20', label: '行程中', type: 'warning'},
    {value: '25', label: '行程中', type: 'warning'},
    {value: '30', label: '行程中', type: 'warning'},
    {value: '35', label: '行程中', type: 'warning'},
    {value: '40', label: '行程中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]
/**
 * 乘客订单评价
 * @type {Array}
 */
const EVALUATION = [
    {value: 0, label: '未评价'},
    {value: 1, label: '1星'},
    {value: 2, label: '2星'},
    {value: 3, label: '3星'},
    {value: 4, label: '4星'},
    {value: 5, label: '5星'}
]
/**
 * 乘客订单状态
 * @type {Array}
 */
const ORDERSUBSTATUS = [
    {value: 10, label: '待开始'},
    {value: 15, label: '待上车'},
    {value: 20, label: '正在接人'},
    {value: 25, label: '等待乘客上车'},
    {value: 30, label: '未上车'},
    {value: 35, label: '已上车'},
    {value: 40, label: '正在送人'},
    {value: 45, label: '已送达'},
    {value: 60, label: '已退票'}
]
const CZORDERSUBSTATUS = [
    {value: 5, label: '待指派', type: 'danger'},
    {value: 10, label: '待上车', type: 'danger'},
    {value: 35, label: '已上车', type: 'warning'},
    {value: 40, label: '已出发', type: 'warning'},
    {value: 43, label: '待支付', type: ''},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]
/**
 * 班次状态
 * @type {Array}
 */
const SHIFTORDERSTATUS = [
    {value: 10, label: '待开始', type: 'danger'},
    {value: 40, label: '行程中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]

const SHIFTORDERSTATUS2 = [
    {value: 10, label: '待发车', type: 'danger'},
    {value: 40, label: '已发车', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]


/**
 * 司机审核状态
 * @type {Array}
 */
const DRIVERAUDITSTATUS = [
    {value: 1, label: '待认证', type: 'info'},
    {value: 2, label: '待审核', type: ''},
    {value: 3, label: '已通过', type: 'success'},
    {value: 4, label: '未通过', type: 'danger'}
]
/**
 * 顺风侠司机审核状态
 * @type {Array}
 */
const SFXDRIVERAUDITSTATUS = [
    {value: 1, label: '待认证', type: 'info'},
    {value: 2, label: '待审核', type: 'warning'},
    {value: 4, label: '已拒绝', type: 'danger'}
]

/**
 * 司机审核状态
 * @type {Array}
 */
const AUDITTYPE = [
    {value: '0', label: '待审核', type: 'warning'},
    {value: 1, label: '已通过', type: 'success'},
    {value: 2, label: '已拒绝', type: 'danger'},
]


/**
 * 司机审核状态
 * @type {Array}
 */
const SETTLEMENTSTATUS = [
    {value: 1, label: '待审核', type: 'warning'},
    {value: 2, label: '已通过', type: 'success'},
]

/**
 * 结算审核状态
 * @type {Array}
 */
const SETTLEAUDITSTATUS = [
    {value: 1, label: '待审核', type: 'warning'},
    {value: 2, label: '已通过', type: 'success'}
]

/**
 * 短信状态
 * @type {Array}
 */
const SMSSTATUS = [
    {value: 1, label: '发送成功', type: 'success'},
    {value: -1, label: '发送失败', type: 'danger'},
    {value: 0, label: '发送中', type: 'warning'}
]
/**
 * 优惠券获取方式
 * @type {Array}
 */
const COUPONOBTAINMETHOD = [
    {value: 1, label: '注册赠送'},
    {value: 2, label: '登录赠送(只限一次)'},
    {value: 3, label: '登录赠送(重复赠送)'},
    {value: 4, label: '分享有礼'},
    {value: 5, label: '活动赠送'},
]

/**
 * 优惠券状态
 * @type {Array}
 */
const COUPONSTATUS = [
    {value: 1, label: '正常', type: 'success'},
    {value: 2, label: '失效', type: 'info'},
]
/**
 * 优惠券类型
 * @type {Array}
 */
const COUPONTYPE = [
    {value: 1, label: '直减'},
    {value: 2, label: '折扣'},
]
/**
 * 优惠券类型
 * @type {Array}
 */
const COUPONRECORDSTATUS = [
    {value: 1, label: '已领取', class: 'util-color-success'},
    {value: 2, label: '已使用', class: 'util-color-secondary'}
]
/**
 * 优惠券类型
 * @type {Array}
 */
const EXIST = [
    {value: 1, label: '有值班司机'},
    {value: 2, label: '无值班司机'}
]
/**
 * 专线订单线路类型
 * @type {Array}
 */
const SCHELINGTYPE = [
    {value: 1, label: '标准模式', sort: '标准', des: '班次指定车辆营运，余票数等于车辆余座数，不支持选座，需设置统一票价'},
    {
        value: 3,
        label: '选座模式',
        sort: '选座',
        des: '班次指定车辆营运，余票数等于车辆余座数，支持选座，可设置不同座位的价格'
    },
    {
        value: 2,
        label: '自由派单',
        sort: '自由',
        des: '线路配多个班次和车辆，新单根据车辆绑定顺序自动派出，可设余票数、不限购'
    },
]

/* 专线工单线路类型 */
const DRIVERORDERTYPE = [
    {value: 1, label: '标准模式', sort: '标准'},
    {value: 2, label: '自由派单', sort: '自由'},
    {value: 3, label: '选座模式', sort: '选座'},
    {value: null, label: '包车', sort: '包车'},
]

const SCHELINGTYPESEARCH = [
    {value: 1, label: '标准模式', sort: '标准', des: '班次指定车辆营运，余票数等于车辆余座数，不支持选座，需设置统一票价'},
    {
        value: 3,
        label: '选座模式',
        sort: '选座',
        des: '班次指定车辆营运，余票数等于车辆余座数，支持选座，可设置不同座位的价格'
    },
    {
        value: 2,
        label: '自由派单',
        sort: '自由',
        des: '线路配多个班次和车辆，新单根据车辆绑定顺序自动派出，可设余票数、不限购'
    },
    {value: -1, label: '未选模式', sort: '', des: ''},
]

/**
 * 优惠券类型
 * @type {Array}
 */
const INVOICESTATUS = [
    {value: 1, label: '开票中'},
    {value: 2, label: '已开票'},
    {value: 3, label: '开票失败'},
    {value: 4, label: '已退票'},
]
/**
 * 优惠券类型
 * @type {Array}
 */
const INVOICETYPE = [
    {value: 2, label: '企业单位'},
    {value: 1, label: '个人/非企业单位'}
]
/**
 * 优惠券类型
 * @type {Array}
 */
const CHANNELALIAS = [
    {value: 'channel_wechat', label: '小程序'},
    {value: 'channel_fast_order', label: '极速购票'},
    {value: 'channel_driver_order', label: '司机'},
    {value: 'system_order', label: '后台'},
    {value: 'ysx_order', label: '云闪行'},
    {value: 'tc_order', label: '同程'},
    {value: '12306_order', label: '出行365'},
    {value: 'channel_agent_order', label: '渠道员'},
    // {value: 'fliggyzx', label: '出行365-飞猪', key: 'distributorCode'},
    // {value: 'meituan', label: '出行365-美团', key: 'distributorCode'},
    // {value: 'umetrip', label: '出行365-航旅纵横', key: 'distributorCode'},
    // {value: 'ctrip', label: '出行365-携程', key: 'distributorCode'},
    // {value: 'tc', label: '出行365-同程', key: 'distributorCode'},
    // {value: '12306', label: '出行365-12306', key: 'distributorCode'},
]

/**
 * 365来源分类
 * @type {Array}
 */
const CHANNEL_365_SOURCES = [

    {value: 'fliggyzx', label: '出行365-飞猪', key: 'distributorCode'},
    {value: 'meituan', label: '出行365-美团', key: 'distributorCode'},
    {value: 'umetrip', label: '出行365-航旅纵横', key: 'distributorCode'},
    {value: 'ctrip', label: '出行365-携程', key: 'distributorCode'},
    {value: 'tc', label: '出行365-同程', key: 'distributorCode'},
    {value: '12306', label: '出行365-12306', key: 'distributorCode'},
]


const CHANNELALIAS2 = [
    {value: 'channel_wechat', label: '小程序'},
    {value: 'channel_fast_order', label: '极速购票'},
    {value: 'channel_driver_order', label: '司机'},
    {value: 'system_order', label: '窗口售票'},
    {value: 'station_order', label: '联网售票'},
    {value: 'mobile_ticketing_order', label: '移动售票'},
    {value: 'tc_order', label: '同程'},
]

const TICKETTYPE = [
    {value: 1, label: '全票'},
    {value: 2, label: '半价票'},
    {value: 3, label: '免票(占座)'},
    {value: 4, label: '免票(不占座)'},
]
/**
 * 优惠券类型
 * @type {Array}
 */
const FLOWINGTYPE = [
    {value: 1, label: '充值', type: '+', class: 'util-money'},
    {value: 2, label: '下单', type: '-', class: 'util-money-minus'},
    {value: 3, label: '退票', type: '+', class: 'util-money'},
]
/**
 * 注册渠道
 * @type {Array}
 */
const REGISTRATIONCHANNEL = [
    {value: '1', label: '乘客端'},
    {value: '2', label: '后台'},
    {value: '3', label: '司机端'},
]
/**
 * 驾照类型
 * @type {Array}
 */
const DRIVERTYPE = [
    {value: 'C3驾驶证', label: 'C3驾驶证'},
    {value: 'C2驾驶证', label: 'C2驾驶证'},
    {value: 'C1驾驶证', label: 'C1驾驶证'},
    {value: 'B2驾驶证', label: 'B2驾驶证'},
    {value: 'B1驾驶证', label: 'B1驾驶证'},
    {value: 'A3驾驶证', label: 'A3驾驶证'},
    {value: 'A2驾驶证', label: 'A2驾驶证'},
    {value: 'A1驾驶证', label: 'A1驾驶证'},
]
const DRIVERSHORTTYPE = [
    {value: 'C2', label: 'C2'},
    {value: 'C1', label: 'C1'},
    {value: 'B2', label: 'B2'},
    {value: 'B1', label: 'B1'},
    {value: 'A3', label: 'A3'},
    {value: 'A2', label: 'A2'},
    {value: 'A1', label: 'A1'},
]
/**
 * 学历
 * @type {Array}
 */
const DRIVEREDUCATION = [
    {value: 81, label: '小学毕业'},
    {value: 71, label: '初中毕业'},
    {value: 61, label: '高中毕业'},
    {value: 51, label: '技校毕业'},
    {value: 41, label: '中专毕业'},
    {value: 31, label: '大专毕业'},
    {value: 21, label: '本科毕业'},
    {value: 17, label: '研究生毕业'},
]
/**
 * 运营商
 * @type {Array}
 */
const MOBILEOPERATORS = [
    {value: 1, label: '中国联通'},
    {value: 2, label: '中国移动'},
    {value: 3, label: '中国电信'},
    {value: 4, label: '其他'},
]

const INCOM_TYPE = [
    {value: null, label: '全部'},
    {value: '完单', label: '完单'},
    {value: '退票', label: '退票'},
    {value: '改签', label: '改签'},
]
const LOADTYPE = [
    {value: 1, label: '未检票'},
    {value: 3, label: '已检票'},
]

const USERTYPECODE = [
    {value: "1", label: "普通管理员"},
    {value: "2", label: "推广售票员"}
]


const BALANCETYPE = [
    {value: 1, label: "账户充值"},
    {value: 2, label: "账户变更"}
]


const RECHARGETYPE = [
    {value: 2, label: "收入"},
    {value: 3, label: "充值"},
    {value: 4, label: "提现 "},
    {value: 5, label: "代充值"},
    {value: 6, label: "代收款"},
    {value: 7, label: "活动奖励"},
    {value: 8, label: "订单退款"},

]
const TRANSFERFAILREASON = [
    {value: 1, label: "转账中"},
    {value: 2, label: "转账成功"},
    {value: 3, label: "转账失败 "},
]

const HITCHHIKINGSTATUS = [
    {value: 10, label: "新订单"},
    {value: 30, label: "已接单"},
    {value: 100, label: "已取消"},
]
const HITCHHIKINGTYPE = [
    {value: 1, label: "城际", tag: 'warning', mapType: '2D'},
    {value: 2, label: "市内", tag: 'success', mapType: '3D'},
]
const POOLTYPE = [
    {value: 1, label: "独享", tag: 'primary'},
    {value: 2, label: "拼车", tag: 'success'},
]

const HITCHHIKINGCHANNEL = [
    {value: 'mt_order', label: "美团"},
]
const BEARHIGHWAYFEE = [
    {value: 1, label: "愿意承担高速费", tag: ''},
    {value: 2, label: "不愿承担高速费", tag: 'info'},
    {value: 3, label: "愿意分摊高速费", tag: ''},
]

const INCOME = [
    {value: '完单', label: '完单'},
    {value: '改签', label: '改签'},
    {value: '退票', label: '退票'},
]

const INVITATIONTYPE = [

    {value: 1, label: '未开始'},
    {value: 2, label: '进行中'},
    {value: 3, label: '已结束'},
    {value: '0', label: '已作废'},
]

const DRIVERSTATUS = [

    {value: 1, label: '待认证'},
    {value: 2, label: '待审核'},
    {value: 3, label: '已通过'},
    {value: '4', label: '已拒绝'},
    {value: 5, label: '已删除'},
]
const CHANNELAPPLYSTATUS = [
    {label: "待认证", value: 1},
    {label: "认证中", value: 2},
    {label: "已通过", value: 3},
    {label: "未通过", value: 4},
]
const BILLSTATUS = [
    {value: 1, label: "已出账"},
    {value: 3, label: "已开票"},
    {value: 2, label: "已结算"},
]
// 使用性质
const USENATURE = [
    {value: '非营运', label: '非营运', type: 'success', color: '#67C23A'},
    {value: '营转非', label: '营转非', type: 'warning', color: '#E6A23C'},
    {value: '出租转非', label: '出租转非', type: 'warning', color: '#E6A23C'},
    {value: '预约出租转非', label: '预约出租转非', type: 'warning', color: '#E6A23C'},
    {value: '营运', label: '营运', type: 'primary', color: '#409EFF'},
    {value: '预约出租客运', label: '预约出租客运', type: 'primary', color: '#409EFF'},
    {value: '其他', label: '其他', type: 'info', color: '#909399'},
]

// 定制使用性质
const CUSTOMUSENATURE = [
    {value: '公路客运', label: '公路客运'},
    {value: '旅游客运', label: '旅游客运'},
    {value: '出租客运', label: '出租客运'},
    {value: '预约出租客运', label: '预约出租客运'},
    {value: '其他', label: '其他'}
]

const PLACEMENTSTATUS = [
    {value: '0', label: '待投放'},
    {value: '1', label: '投放中'},
    {value: '2', label: '已完成'},
]
const CZACCOUNTTYPE = [
    {value: 1, label: '业务员'},
    {value: 2, label: '调度员'},
]
const PAYTYPE = [
    {value: '微信', label: '微信'},
    {value: '支付宝', label: '支付宝'},
]
const SEATTYPE = [
    {value: 1, label: '独享'},
    {value: 2, label: '拼座'},
]
// 证件类型
const CARDTYPELIST = [
    {label: '居民身份证', value: 1},
    {label: '港澳居民通行证', value: 2},
    {label: '台湾居民通行证', value: 3},
    {label: '港澳居民居住证', value: 4},
    {label: '台湾居民居住证', value: 5},
    {label: '外国人永久居留身份证', value: 6},
    {label: '中国护照', value: 7},
    {label: '外国护照', value: 8},
]

const CARDRULES = {
    1: {
        rules: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
        defaultReg: /(.{6}).*(.{4})/,
        defaultReplace: '$1********$2',
        maxLength: 18
    },
    2: {
        rules: /^[HM]\d{8}$/,
        defaultReg: /(.{3}).*(.{2})/,
        defaultReplace: '$1****$2',
        maxLength: 9
    },
    3: {
        rules: /^[0-9]{8}$/,
        defaultReg: /(.{2}).*(.{2})/,
        defaultReplace: '$1****$2',
        maxLength: 8
    },
    4: {
        rules: /^[0-9]{18}$/,
        defaultReg: /(.{6}).*(.{4})/,
        defaultReplace: '$1********$2',
        maxLength: 18
    },
    5: {
        rules: /^[0-9]{18}$/,
        defaultReg: /(.{6}).*(.{4})/,
        defaultReplace: '$1********$2',
        maxLength: 18
    },
    6: {
        rules: /^[0-9]{18}$/,
        defaultReg: /(.{6}).*(.{4})/,
        defaultReplace: '$1********$2',
        maxLength: 18
    },
    7: {
        rules: /^[A-Za-z0-9]{9}$/,
        defaultReg: /(.{3}).*(.{2})/,
        defaultReplace: '$1****$2',
        maxLength: 9
    },
    8: {
        rules: /^[A-Za-z0-9]{9,17}$/,
        defaultReg: /(.{3}).*(.{2})/,
        defaultReplace: '$1****$2',
        maxLength: 17
    }
}

const LINESTATUS = [
    {label: '运行中', value: 1},
    {label: '已停用', value: 2}
]


//   文旅-预约状态
const TRAVELRESERVATIONSTATUSFILTER = [
    {label: '待开始', value: '5,6,7', type: 'danger'},
    {label: '行程中', value: 40, type: ''},
    {label: '已完成', value: 45, type: ''},
    {label: '已取消', value: 60, type: 'info'},
    {label: '待支付', value: 1, type: 'success'},
]
//   文旅-预约状态
const TRAVELRESERVATIONSTATUS = [
    {label: '待确认', value: 5, type: 'danger'},
    {label: '确认中', value: 6, type: 'warning'},
    {label: '已确认', value: 7, type: ''},
    {label: '行程中', value: 40, type: ''},
    {label: '已完成', value: 45, type: ''},
    {label: '已取消', value: 60, type: 'info'},
    {label: '待支付', value: 1, type: 'success'},
]
//   文旅-订单状态
const TRAVELORDERSTATUS = [
    {label: '待派车', value: 8, type: 'danger'},
    {label: '已派车', value: 10, type: 'warning'},
    {label: '行程中', value: 40, type: ''},
    {label: '已完成', value: 45, type: 'success'},
    {label: '已取消', value: 60, type: 'info'},
]
// 文旅-全部订单状态
const TRAVELALLORDERSTATUS = [
    {label: '待支付', value: 1, type: 'danger'},
    {label: '待确认', value: 5, type: 'warning'},
    {label: '待派车', value: 8, type: 'warning'},
    {label: '已派车', value: 10, type: 'success'},
    {label: '行程中', value: 40, type: 'success'},
    {label: '已完成', value: 45, type: ''},
    {label: '已取消', value: 60, type: 'info'},
]
// 文旅-行程状态
const TRAVELTRIPSTATUS = [
    {label: '待开始', value: 10, type: 'warning'},
    {label: '行程中', value: 40, type: 'info'},
    {label: '已完成', value: 45, type: 'success'},
    {label: '已取消', value: 60, type: 'success'},
]
// 文旅-订单来源
const TRAVELORDERSOURCE = [
    {label: '后台下单', value: 'system_order'},
    {label: '小程序', value: 'channel_wechat'},
]
const URGENCYLIST = [
    {label: '紧急', value: 1, color: '#FF0000'},
    {label: '高', value: 2, color: '#FF0000'},
    {label: '中', value: 3, color: ''},
    {label: '低', value: 4, color: ''},
]
// 客诉工单状态：1-新工单，2-已关闭
const WORKORDERSTATUS = [
    {label: '新工单', value: 1, type: 'success'},
    {label: '已关闭', value: 2, type: 'info'},
]
// 客诉处理方式 1-改派车辆，2-封禁司机，3-订单退款
const HANDLETYPE = [
    {
        label: '改派车辆',
        key: "reassign",
        value: 1,
        tips: '乘客联系不上司机时，可将订单改派给其他车辆',
        bgColor: '#0288FF',
        imgs: require('@/assets/img/handle-reassign.png')
    },
    {
        label: '封禁司机',
        key: "ban",
        value: 2,
        tips: '若司机触及收费、引导线下交易等问题，可封禁司机账号',
        bgColor: '#35363B',
        imgs: require('@/assets/img/handle-ban.png')
    },
    {
        label: '订单退款',
        key: "refund",
        value: 3,
        tips: '乘客不认可车费、高速费、可申请部分或全额退款',
        bgColor: '#06CD6A',
        imgs: require('@/assets/img/handle-refund.png')
    },
]
const LICENSECOLOR = [
    {
        label: '蓝色',
        value: '蓝色',
        color: '#0159EA',
        styles: {backgroundColor: '#0159EA', border: '1px solid #FFFFFF', color: '#FFFFFF'}
    },
    {
        label: '黄色',
        value: '黄色',
        color: '#FFD00D',
        styles: {backgroundColor: '#FFD00D', border: '1px solid #333333', color: '#333333'}
    },
    {
        label: '黑色',
        value: '黑色',
        color: '#333333',
        styles: {backgroundColor: '#333333', border: '1px solid #333333', color: '#333333'}
    },
    {
        label: '白色',
        value: '白色',
        color: '#FFFFFF',
        styles: {backgroundColor: '#FFFFFF', border: '1px solid #333333', color: '#333333'}
    },
    {
        label: '绿色',
        value: '绿色',
        color: '#8CFFB0',
        styles: {
            background: 'linear-gradient(180deg, #DAFBF0 0%, #8CFFB0 100%)',
            border: '1px solid #FFFFFF',
            color: '#FFFFFF'
        }
    },
]
const VEHICLECOLOR = [
    {label: '蓝色', value: '蓝色', color: '#4081E3'},
    {label: '黄色', value: '黄色', color: '#F6BD4A'},
    {label: '黑色', value: '黑色', color: '#000000'},
    {label: '白色', value: '白色', color: '#FFFFFF'},
    {label: '棕色', value: '棕色', color: '#804316'},
    {label: '金色', value: '金色', color: '#C48F3A'},
    {label: '银色', value: '银色', color: '#E7E7E7'},
    {label: '绿色', value: '绿色', color: '#57CE8C'},
    {label: '灰色', value: '灰色', color: '#F4F6F8'},
    {label: '红色', value: '红色', color: '#FE5531'},
]

const PROTOCOLTYPE = new Map([

    [1, {
        name: "乘客端",
        tips: "在登录页、个人中心向用户展示",
        title: "乘客端《隐私政策》",
        desc: "* 启用后将在小程序登录页、个人中心展示<br />* 用户须同意并勾选协议，才能正常登录和注册<br />* 保持开启，否则微信小程序可能会审核失败！"
    }],
    [2, {
        name: "乘客端",
        tips: "小程序下单时会弹出给用户看",
        title: "乘客端《乘车须知》",
        desc: "* 启用后，小程序专线/班线、专线包车下单时弹出乘车须知<br />* 乘客须同意并勾选协议，才能完成下单"
    }],
    [3, {
        name: "司机端",
        tips: "在登录页、个人中心向司机展示",
        title: "司机端《隐私政策》",
        desc: "* 启用后将在司机端登录页、个人中心展示<br />* 司机须同意并勾选协议，才能正常登录和注册"
    }],
    [4, {
        name: "移动售票端",
        tips: "在登录页、个人中心向售票员展示",
        title: "移动售票端《隐私政策》"
    }],
    [5, {
        name: "司机端",
        tips: "在登录页、车主认证页向用户展示",
        title: "司机端《服务标准协议》",
        desc: "* 启用后，车主在司机端认证时，会显示《车主服务协议》<br />* 车主认证时，需勾选同意《车主服务协议》才可提交车主认证"
    }],
    [6, {
        name: "司机端",
        tips: "在车主认证页向用户展示",
        title: "司机端《车主认证常见问题》",
        desc: "* 启用后，车主在司机端认证时，会显示《车主认证常见问题》<br />* 车主认证时，可参考该《车主认证常见问题》处理认证过程中的问题"
    }],
    [7, {
        name: "司机端",
        tips: "在登录页、车主认证页向用户展示",
        title: "司机端《违约责任的认定》",
        desc: "* 启用后，车主在司机端认证时，会显示《违约责任认定》<br />* 车主认证时，需勾选同意《违约责任认定》才可提交车主认证"
    }],
    [8, {
        name: "司机端",
        tips: "在账户认证页面向司机展示",
        title: "司机端《认证常见问题》",
        desc: "* 启用后，车主在司机端认证时，会显示《认证常见问题》"
    }],
    [13, {
        name: "乘客端",
        tips: "在用户预约文旅商品时向用户展示",
        title: "乘客端《平台服务协议》",
        desc: "* 启用后，用户在预约文旅商品时，会显示《平台服务协议》",
        disabled: true
    }],
    [14, {
        name: "乘客端",
        tips: "在用户预约文旅商品时向用户展示",
        title: "乘客端《车辆租赁协议》",
        desc: "* 启用后，用户在预约文旅商品时，会显示《车辆租赁协议》",
        disabled: true
    }],
    [15, {
        name: "乘客端",
        tips: "在用户预约文旅商品时向用户展示",
        title: "乘客端《代驾服务协议》",
        desc: "* 启用后，用户在预约文旅商品时，会显示《代驾服务协议》",
        disabled: true
    }],
    [16, {
        name: "司机端",
        tips: "在登录页、个人中心向用户展示",
        title: "乘客端《用户协议》",
        desc: "* 启用后，在登录页、个人中心会显示《用户协议》",
    }],
    [17, {
        name: "司机端",
        tips: "在司机申请提现时向司机展示",
        title: "乘客端《提现须知》",
        desc: "* 启用后，在司机申请提现时，会显示《提现须知》",
    }],
    [18, {
        name: "乘客端",
        tips: "在登录页、个人中心向用户展示",
        title: "乘客端《用户协议》",
        desc: "* 启用后，在登录页、个人中心会显示《用户协议》",
    }],

    [19, {
        name: "司机端",
        tips: "司机端第一次登录向司机展示",
        title: "司机端《隐私政策弹窗》",
        desc: "* 启用后，司机端第一次登录，会显示《隐私政策弹窗》",
    }],
    [20, {
        name: "渠道端",
        tips: "渠道端第一次登录向司机展示",
        title: "渠道端《隐私政策弹窗》",
        desc: "* 启用后，渠道h5注册，会显示《用户协议弹窗》",
    }],
    [21, {
        name: "渠道端",
        tips: "渠道端第一次登录向司机展示",
        title: "渠道端《隐私政策弹窗》",
        desc: "* 启用后，渠道h5注册，会显示《隐私政策弹窗》",
    }],
])

const SERVICEVEHICLETYPE = [
    {label: '租赁车辆+代驾', value: 1},
    {label: '定制客运', value: 2},
    {label: '网约车', value: 3},
]

const LYPOOLTYPE = [
    {label: '拼车', value: 2},
    {label: '包车', value: 1}
]
const LYLINETYPE = [
    {label: '去程', value: 1},
    {label: '返程', value: 2},
    {label: '往返', value: 3}
]

const RISKLEVELLIST = [
    {label: "正常", value: "1", color: '#67C23A'},
    {label: "轻微风险", value: "2", color: '#85ce61'},
    {label: "低风险", value: "3", color: '#E6A23C'},
    {label: "中低风险", value: "4", color: '#f5a623'},
    {label: "中风险", value: "5", color: '#ff9900'},
    {label: "高风险", value: "6", color: '#F56C6C'},
    {label: "严重风险", value: "7", color: '#fa5555'},
]

const LINECATEGORY = [
    {label: "一类", value: "1"},
    {label: "二类", value: "2"},
    {label: "三类", value: "3"},
    {label: "四类", value: "4"},
]
const LINEMODE = [
    {label: "上门接送", value: "1"},
    {label: "定点接送", value: "2"},
    {label: "短途驳载", value: "3"},
    {label: "其它", value: "0"},
]

const ACTIVITYTYPE = [
    {label: "惊喜盲盒", value: "1"},
]

const ACTIVITYSTATUS = [
    {label: "未开始", value: "1", tag: ''},
    {label: "进行中", value: "2", tag: 'success'},
    {label: "已结束", value: "3", tag: 'info'},
    {label: "已作废", value: "4", tag: 'info'},
]

/**
 * 发票种类编码(默认
 * 026):01-数电票(增值税
 * 专用发票),02-数电票
 * (普通发票),85-数电纸
 * 质发票(增值税专用发
 * 票),86-数电纸质发票
 * (普通发票),87-数电纸
 * 质发票(机动车销售统
 * 一发票),88-数电纸质
 * 发票(二手车销售统一
 * 发票),004-增值税专用
 * 发票,005-机动车销售
 * 统一发票,006-二手车
 * 销售统一发票,007-增
 * 值税普通发票,025-增
 * 值税普通发票(卷式
 * ),026-增值税电子普通
 * 发票,028-增值税电子
 * 专用发票
 */
const INVOICETYPECODE = [
    {value: "01", label: "数电票(增值税专用发票)"},
    {value: "02", label: "数电票(普通发票)"},
    {value: "85", label: "数电纸质发票(增值税专用发票)"},
    {value: "86", label: "数电纸质发票(普通发票)"},
    {value: "87", label: "数电纸质发票(机动车销售统一发票)"},
    {value: "88", label: "数电纸质发票(二手车销售统一发票)"},
    {value: "004", label: "增值税专用发票"},
    {value: "005", label: "机动车销售统一发票"},
    {value: "006", label: "二手车销售统一发票"},
    {value: "007", label: "增值税普通发票"},
    {value: "025", label: "增值税普通发票(卷式)"},
    {value: "026", label: "增值税电子普通发票"},
    {value: "028", label: "增值税电子专用发票"}
]

/**
 * 特定业务标志(默认
 * 00):00-普通发票,01-成
 * 品油,02-稀土,03-建筑
 * 服务,04-货物运输服务
 * ,05-不动产销售,06-不
 * 动产经营租赁服务,09-
 * 旅客运输服务,12-自产
 * 农产品销售,14-机动车
 * ,15-二手车,16-农产品
 * 收购,24-报废产品收购
 * ,32-电子烟
 */
const INVOICESPECIALMARK = [
    {value: "00", label: "普通发票"},
    {value: "01", label: "成品油"},
    {value: "02", label: "稀土"},
    {value: "03", label: "建筑服务"},
    {value: "04", label: "货物运输服务"},
    {value: "05", label: "不动产销售"},
    {value: "06", label: "不动产经营租赁服务"},
    {value: "09", label: "旅客运输服务"},
    {value: "12", label: "自产农产品销售"},
    {value: "14", label: "机动车"},
    {value: "15", label: "二手车"},
    {value: "16", label: "农产品收购"},
    {value: "24", label: "报废产品收购"},
    {value: "32", label: "电子烟"}
]

/**
 * 优惠政策名称(增值税
 * 特殊管理):简易征收、
 * 稀土产品、免税、不
 * 征税、先征后退、
 * 100%先征后退、
 * 50%先征后退、按
 * 3%简易征收、按
 * 5%简易征收、按
 * 5%简易征收减按
 * 1.5%计征、即征即退
 * 30%、即征即退50%、
 * 即征即退70%、即征
 * 即退100%、超税负
 * 3%即征即退、超税负
 * 8%即征即退、超税负
 * 12%即征即退、超税
 * 负6%即征即退(当
 * preferentialMark为
 * 1时，此项必填)
 */
const VATSPECIALMANAGEMENT = [
    {value: "简易征收", label: "简易征收"},
    {value: "稀土产品", label: "稀土产品"},
    {value: "免税", label: "免税"},
    {value: "不征税", label: "不征税"},
    {value: "先征后退", label: "先征后退"},
    {value: "100%先征后退", label: "100%先征后退"},
    {value: "50%先征后退", label: "50%先征后退"},
    {value: "按3%简易征收", label: "按3%简易征收"},
    {value: "按5%简易征收", label: "按5%简易征收"},
    {value: "按5%简易征收减按1.5%计征", label: "按5%简易征收减按1.5%计征"},
    {value: "即征即退30%", label: "即征即退30%"},
    {value: "即征即退50%", label: "即征即退50%"},
    {value: "即征即退70%", label: "即征即退70%"},
    {value: "即征即退100%", label: "即征即退100%"},
    {value: "超税负3%即征即退", label: "超税负3%即征即退"},
    {value: "超税负8%即征即退", label: "超税负8%即征即退"},
    {value: "超税负12%即征即退", label: "超税负12%即征即退"},
    {value: "超税负6%即征即退", label: "超税负6%即征即退"}
]

/**
 * 渠道状态
 * @type {Array}
 */
const CHANNEL_STATUS = [
    {value: 0, label: '待审核', type: 'warning'},
    {value: 1, label: '正常', type: 'success'},
    {value: 2, label: '禁用', type: 'info'},
    {value: 3, label: '审核拒绝', type: 'danger'}
]

/**
 * 渠道审核状态
 * @type {Array}
 */
const CHANNEL_AUDIT_STATUS = [
    {value: 0, label: '待审核', type: 'warning'},
    {value: 1, label: '审核通过', type: 'success'},
    {value: 2, label: '审核通过', type: 'success'},
    {value: 3, label: '审核拒绝', type: 'danger'}
]

/**
 * 渠道佣金类型
 * @type {Array}
 */
const CHANNEL_COMMISSION_TYPE = [
    {value: 1, label: '固定金额'},
    {value: 2, label: '比例'}
]

/**
 * 渠道佣金结算周期
 * @type {Array}
 */
const CHANNEL_COMMISSION_SETTLEMENT_PERIOD = [
    {value: 1, label: '实时结算', desc: '订单完成即可提现'},
    {value: 2, label: 'T+1结算', desc: '次日可提现'},
    {value: 3, label: 'T+7结算', desc: '7天后可提现'},
    // {value: 4, label: '按月结算', desc: '次月可提现'}
]

/**
 * 渠道线路配置状态
 * @type {Array}
 */
const CHANNEL_LINE_CONFIG_STATUS = [
    {value: 1, label: '开启', type: 'success'},
    {value: 2, label: '关闭', type: 'info'}
]

/**
 * 渠道佣金配置类型
 * @type {Array}
 */
const CHANNEL_COMMISSION_CONFIG_TYPE = [
    {value: 1, label: '全局配置'},
    {value: 2, label: '机构配置'},
    {value: 3, label: '线路配置'}
]

/**
 * 渠道订单支付方式
 * @type {Array}
 */
const CHANNEL_PAYMENT_TYPE = [
    {value: 1, label: '用户扫码支付'},
    {value: 2, label: '渠道代付'}
]

/**
 * 渠道订单支付方式（字符串枚举）
 * @type {Array}
 */
const CHANNEL_PAYMENT_CHANNEL = [
    {value: 'CHANNEL_PAY', label: '渠道代付'},
    {value: 'CHANNEL_SCAN', label: '用户扫码付款'}
]

/**
 * 渠道订单佣金状态
 * @type {Array}
 */
const CHANNEL_COMMISSION_STATUS = [
    {value: 1, label: '未结算', type: 'warning'},
    {value: 2, label: '已结算', type: 'success'},
    {value: 3, label: '已扣除', type: 'danger'}
]

/**
 * 渠道提现状态
 * @type {Array}
 */
const CHANNEL_WITHDRAWAL_STATUS = [
    {value: 1, label: '待审核', type: 'warning'},
    {value: 2, label: '审核通过', type: 'success'},
    {value: 3, label: '审核拒绝', type: 'danger'}
]

/**
 * 渠道提现转账状态
 * @type {Array}
 */
const CHANNEL_WITHDRAWAL_TRANSFER_STATUS = [
    {value: 1, label: '转账成功', type: 'success'},
    {value: 2, label: '转账失败', type: 'danger'},
    {value: 3, label: '转账中', type: 'warning'}
]

/**
 * 渠道提现到账天数
 * @type {Array}
 */
const CHANNEL_WITHDRAWAL_ARRIVAL_DAYS = [
    {value: '0', label: 'T+0 实时到账'},
    {value: '1', label: 'T+1 次日到账'},
    {value: '3', label: 'T+3 三日到账'},
    {value: '7', label: 'T+7 七日到账'}
]

/**
 * 渠道充值状态
 * @type {Array}
 */
const CHANNEL_RECHARGE_STATUS = [
    {value: 1, label: '支付中', type: 'warning'},
    {value: 2, label: '支付成功', type: 'success'}
]

/**
 * 渠道流水类型
 * @type {Array}
 */
const CHANNEL_FLOW_TYPE = [
    {value: 1, label: '佣金收入', type: 'success'},
    {value: 2, label: '提现支出', type: 'warning'},
    {value: 3, label: '代付支出', type: 'warning'},
    {value: 4, label: '代付回退', type: 'danger'},
    {value: 5, label: '账户充值', type: 'success'},
]

/**
 * 渠道流水关联类型
 * @type {Array}
 */
const CHANNEL_FLOW_REF_TYPE = [
    {value: 1, label: '订单'},
    {value: 2, label: '提现'},
    {value: 3, label: '充值'},
]

/**
 * 渠道订单状态（筛选用）
 * @type {Array}
 */
const CHANNEL_ORDER_STATUS = [
    {value: 10, label: '进行中', type: 'warning'},
    {value: 45, label: '已完成', type: 'success'},
    {value: 60, label: '已取消', type: 'info'}
]

module.exports = {
    LINECATEGORY,
    LINEMODE,
    ACTIVITYTYPE,
    LICENSECOLOR,
    VEHICLECOLOR,
    TRAVELRESERVATIONSTATUS,
    TRAVELRESERVATIONSTATUSFILTER,
    TRAVELORDERSTATUS,
    TRAVELALLORDERSTATUS,
    TRAVELTRIPSTATUS,
    TRAVELORDERSOURCE,
    CARDTYPELIST,
    CARDRULES,
    CHANNELAPPLYSTATUS,
    DRIVERSTATUS,
    INVITATIONTYPE,
    TRANSFERFAILREASON,
    RECHARGETYPE,
    BALANCETYPE,
    ORDERSTATUS2,
    LOADTYPE,
    INVOICETYPE,
    INVOICESTATUS,
    CHANNELALIAS,
    CHANNELALIAS2,
    FLOWINGTYPE,
    GENDER,
    CANCELCHANNEL,
    BILLSTATUS,
    SEATNUMBER,
    LINETYPE,
    ORDERSTATUS,
    ORDERCHARTEREDSTATUS,
    SCHELINGTYPE,
    SCHELINGTYPESEARCH,
    DRIVERORDERTYPE,
    ORDERSUBSTATUS,
    SHIFTORDERSTATUS,
    DRIVERAUDITSTATUS,
    SFXDRIVERAUDITSTATUS,
    COUPONRECORDSTATUS,
    SETTLEAUDITSTATUS,
    SMSSTATUS,
    COUPONOBTAINMETHOD,
    COUPONSTATUS,
    ORDERASSIGNMETHOD,
    COUPONTYPE,
    EXIST,
    EVALUATION,
    REGISTRATIONCHANNEL,
    DRIVERTYPE,
    DRIVERSHORTTYPE,
    DRIVEREDUCATION,
    MOBILEOPERATORS,
    INCOM_TYPE,
    TICKETTYPE,
    SHIFTORDERSTATUS2,
    USERTYPECODE,
    SETTLEMENTSTATUS,
    AUDITTYPE,
    HITCHHIKING,
    HITCHHIKINGTYPE,
    HITCHHIKINGSTATUS,
    POOLTYPE,
    HITCHHIKINGCHANNEL,
    BEARHIGHWAYFEE,
    HITCHHIKINGWORK,
    INCOME,
    HITCHHIKINGDAN,
    HITCHHIKINGWORKTWO,
    USENATURE,
    CUSTOMUSENATURE,
    PLACEMENTSTATUS,
    CZACCOUNTTYPE,
    CZHITCHHIKING,
    PAYTYPE,
    SEATTYPE,
    CZHITCHHIKINGDAN,
    CZORDERSUBSTATUS,
    LINESTATUS,
    URGENCYLIST,
    WORKORDERSTATUS,
    HANDLETYPE,
    PROTOCOLTYPE,
    SERVICEVEHICLETYPE,
    LYPOOLTYPE,
    LYLINETYPE,
    RISKLEVELLIST,
    ACTIVITYSTATUS,
    INVOICETYPECODE,
    INVOICESPECIALMARK,
    VATSPECIALMANAGEMENT,
    CHANNEL_365_SOURCES,
    CHANNEL_STATUS,
    CHANNEL_AUDIT_STATUS,
    CHANNEL_COMMISSION_TYPE,
    CHANNEL_COMMISSION_SETTLEMENT_PERIOD,
    CHANNEL_LINE_CONFIG_STATUS,
    CHANNEL_COMMISSION_CONFIG_TYPE,
    CHANNEL_PAYMENT_TYPE,
    CHANNEL_PAYMENT_CHANNEL,
    CHANNEL_COMMISSION_STATUS,
    CHANNEL_WITHDRAWAL_STATUS,
    CHANNEL_WITHDRAWAL_TRANSFER_STATUS,
    CHANNEL_WITHDRAWAL_ARRIVAL_DAYS,
    CHANNEL_RECHARGE_STATUS,
    CHANNEL_FLOW_TYPE,
    CHANNEL_FLOW_REF_TYPE,
    CHANNEL_ORDER_STATUS,

}
